<ion-chip [matTooltip]="tipText" class="h-2" [color]="color">{{text}}</ion-chip>
